import { isBefore, isMatch, isEqual } from "date-fns";
import { CourseStatus } from "generated/graphql";
import { ICourseDelivery, ICoursePickup } from "./data/types";

export const checkCoursePaths =
  "/dashboard" ||
  "/dashboard/unassigned" ||
  "/dashboard/assigned" ||
  "/dashboard/completed" ||
  "/dashboard/toreschedule";

export const STATUS_CHECK = [CourseStatus.Assigned, CourseStatus.OnGoing, CourseStatus.Done];
export const STATUS_CHECK_MENU = [CourseStatus.OnGoing, CourseStatus.Done];

export const COURSES_STATUS = {
  0: [CourseStatus.Default, CourseStatus.NotStarted],
  1: [CourseStatus.Assigned, CourseStatus.OnGoing],
  2: [CourseStatus.Done],
  3: [CourseStatus.OnGoing],
};
interface ColorPalette {
  backgroundColor: string;
  color: string;
  text: string;
}
export const COURSES_STATUS_COLORS: Record<string, ColorPalette> = {
  [CourseStatus.Default]: {
    backgroundColor: "rgba(151, 151, 151, 0.2)",
    color: "#979797",
    text: "Unassigned",
  },
  [CourseStatus.NotStarted]: {
    backgroundColor: "rgba(151, 151, 151, 0.2)",
    color: "#979797",
    text: "Not started",
  },
  [CourseStatus.OnGoing]: {
    backgroundColor: "rgba(242, 153, 74, 0.2)",
    color: "#f2994a",
    text: "Ongoing",
  },
  [CourseStatus.Done]: {
    backgroundColor: "rgba(43, 168, 21, 0.2)",
    color: "#2ba815",
    text: "Done",
  },
};

export const isDateValid = (date: string) => {
  return isMatch(date.trim(), "yyyy-MM-dd");
};
export const validateDeliveryDate = (pickups: ICoursePickup[], currentDelivery: ICourseDelivery) => {
  const foundedPickup = pickups?.find((pickup: ICoursePickup) => pickup?.reference === currentDelivery?.reference);
  if (!foundedPickup) return false;
  const [pickuDate, pickupMinutes] = foundedPickup?.delay?.split("/") || [];
  const [deliveryDate, deliveryMinutes] = currentDelivery?.delay?.split("/") || [];
  return isEqual(new Date(pickuDate), new Date(deliveryDate)) || isBefore(new Date(pickuDate), new Date(deliveryDate));
};
